import React from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import WhatsAppBadge from "../components/common/WhatsAppBadge";

const PublicLayout = () => {
  return (
    <Box>
      <Header />
      <Outlet />
      <WhatsAppBadge />
      <Footer />
    </Box>
  );
};

export default PublicLayout;
